import PrivacyPolicyPage from '@/Page/PrivacyPolicyPage';
import { GetServerSideProps } from 'next';
import { NextSeo } from 'next-seo';
import { useTranslation } from 'next-i18next';
import { WEBSITE_URL } from '@/Data/Constants';
import { sharedServerSideLogic } from '@/Services/SsrService/sharedServerSideLogic';

export default function PrivacyPage() {
  const { t } = useTranslation(['common']);

  return (
    <>
      <NextSeo
        title={t('common:seo_info.privacy_policy.title')!}
        description={t('common:seo_info.privacy_policy.description')!}
        canonical={`${WEBSITE_URL}/privacy-policy`}
        openGraph={{
          url: `${WEBSITE_URL}/privacy-policy`,
          title: t('common:seo_info.privacy_policy.title')!,
          description: t('common:seo_info.privacy_policy.description')!,
          images: [
            {
              url: 'https://beta.joyla.uz/static/icons/logo.svg',
              alt: 'Joyla',
            },
          ],
          siteName: 'Joyla',
        }}
      />
      <>
        <PrivacyPolicyPage />
      </>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = sharedServerSideLogic();
